export default __webpack_public_path__ + "static/CORPORATE_SITE__HEADER_MB_WHOWEARE-3ba5a5ed44442c6a9c24ca2421c02d99.jpg";